import React, {Component, PropTypes} from 'react';

import BasicLayout from 'layouts/Basic';
import MatchesIndepth from 'components/matches/Indepth';
// import MatchesList from 'components/matches/List';
import MatchesDataGrid from 'components/matches/DataGrid';
import MatchesControl from 'components/matches/Control';

const Page = props => {
  return (
    <BasicLayout
      main={<MatchesDataGrid {...props} />}
      aside={<MatchesControl {...props} />}
      hero={props.selected && <MatchesIndepth {...props} />}
    />
  );
};

import {updateMatchesRequested, toggleMatchApproved} from 'actions/index';

import {resource} from 'utils/resourcerizer';
import {connect} from 'react-redux';

import {MATCHES_NS} from 'constants/index';

const mstp = state => ({
  isMatching: state.matches.isMatching,
});

const mdtp = dispatch => ({
  toggleMatchApproved: id => () =>
    dispatch(toggleMatchApproved(id)),
  updateMatchesRequested: () => dispatch(updateMatchesRequested()),
});

Page.Container = resource(MATCHES_NS)(connect(mstp, mdtp)(Page));

export default Page;



// WEBPACK FOOTER //
// ./src/components/matches/Page.jsx